export default {
  backendUrl: process.env.VUE_APP_API_PATH,
  supportEmail: process.env.VUE_APP_SUPPORT_EMAIL,
  appTitle: process.env.VUE_APP_TITLE||"Codex",
}
